import { forwardRef } from "react";

import Stack from "@/tpo/Stack";
import { useTheme } from "styled-components";

export const ReportListCardShell = forwardRef(
  ({ children, onClick, "data-component-name": dataComponentName, bg, cursor, ...sx }, ref) => {
    const theme = useTheme();

    return (
      <Stack
        ref={ref}
        py={40}
        px={28}
        bg={bg}
        gap={20}
        borderRadius={theme.radius.card}
        onClick={onClick}
        cursor={cursor}
        data-component-name={dataComponentName}
        {...sx}
      >
        {children}
      </Stack>
    );
  }
);

ReportListCardShell.defaultProps = {
  bg: "white",
  cursor: "pointer"
};
